import { motion } from 'framer-motion';

export function GlowPulse({ color, intensity = 0.06 }: { color: string; intensity?: number }) {
  return <motion.div className='pointer-events-none absolute inset-0' animate={{ opacity: [intensity, intensity * 2.5, intensity] }} transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' as const }} style={{ background: `radial-gradient(ellipse 60% 50% at 50% 50%, ${color}15 0%, transparent 70%)` }} aria-hidden='true' />;
}
